//
import Model from "@/models/Model"

/**
* This class describes a authorize.
*
* @class      AAuthorize (name)
*/
export default class AInArmed extends Model {

  /**
   * { function_description }
   *
   * @return     {string}  { description_of_the_return_value }
   */
  resource() {
    return 'in_armed'
  }
}